export const CORE_TABS = [
	{
		title: 'فروش',
		id: 0,
	},
	{
		title: '  آمار آگهی ها',
		id: 1,
	},
];

export const OFFCB_TABS = [
	{
		title: 'فروش',
		id: 0,
	},
	{
		title: '  تراکنش ها',
		id: 1,
	},
];
export const TITLE_REPORTS = [
	{
		title: 'گزارش سرویس آگهی تخفیف',
		id: 0,
	},
	{
		title: 'گزارش سرویس برگشت پول',
		id: 1,
	},
];

export const TITLE_CHART = [
	{
		id: 1,
		title: 'مبلغ فروش آگهی',
	},
	{
		id: 2,
		title: 'تعداد آگهی ابطال شده',
	},
	{
		id: 3,
		title: 'مبلغ فروش ',
	},
	{
		id: 4,
		title: 'تعداد فروش (تراکنش)',
	},
];

export const DATE_RANGE = {
	today: 'امروز',
	week: '۷ روز اخیر',
	month: '۳۰ روز اخیر',
};
